import { Component, Inject, Mixins } from '@/vue-property-decorator'
import { GameNameVerticalBase } from './cssVar/gameNameVerticalBase'
import { GameNameVerticalDefault } from './cssVar/gameNameVerticalDefault'
import { GameNameVerticalSmall } from './cssVar/gameNameVerticalSmall'
import { GetCssVarManager } from '@/views/game/components/gameCardSuit/components/baseCssVarProvide'
import { VerticalPropsCyanBlue } from '..'
import { useMainStore } from '@/store/index'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import style from './style.module.scss'
export type GameNameVerticalCssVarManager =
  GetCssVarManager<GameNameVerticalBase>
/** 游戏名称上下结构 */
@Component<GameNameVertical>({
  name: 'GameNameVertical'
})
export default class GameNameVertical extends Mixins<
  BaseCssVarInject<GameNameVerticalBase>
>(BaseCssVarInject) {
  /** 获得默认样式 */
  public static getCssVarDefault = () => new GameNameVerticalDefault()
  /** 获得小号样式 */
  public static getCssVarSmall = () => new GameNameVerticalSmall()

  @Inject() cardProps!: Required<VerticalPropsCyanBlue>
  private get isWeb() {
    return useMainStore().isWeb
  }
  /** 渲染游戏名称 */
  render() {
    const { gameName, logoUrl } = this.cardProps
    return (
      <div
        class={{
          [style['game-name-vertical']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
      >
        <my-img
          class={style['top-logo']}
          src={logoUrl}
          options={{ type: 'div' }}
        ></my-img>
        <div class={style['bottom-name-wrapper']}>
          <p class={style['bottom-name']}>{gameName}</p>
        </div>
      </div>
    )
  }
}
